'use client';

import { useState } from 'react';

import { CloseEyeIcon, OpenEyeIcon } from '@/assets';
import { cn } from '@/lib/utils';

function Input({ className, type, ...props }) {
  //-------------- State & Variables --------------//
  const isPasswordType = type == 'password';
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  //-------------- Other Methods --------------//

  return (
    <>
      <input
        type={isPasswordType ? (isPasswordVisible ? 'text' : 'password') : type}
        data-slot="input"
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-11 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          isPasswordType && 'pr-10',
          className
        )}
        autoComplete="off"
        {...props}
      />
      {isPasswordType && (
        <button
          type="button"
          className="absolute top-11 right-1 flex size-6 -translate-1/2 cursor-pointer items-center justify-center [&>svg]:size-5"
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
        >
          {!isPasswordVisible ? <CloseEyeIcon /> : <OpenEyeIcon />}
        </button>
      )}
    </>
  );
}

export { Input };

